<app-header></app-header>

<!-- <app-skip-to-content></app-skip-to-content> -->

<div class="govuk-width-container">
  <alert role="alert" tabindex="0"></alert>
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-beat" [fullScreen]="true">
    <p style="text-align: center; color: white"> Processing - Do not close this window <br /> <br />
      Stay on this page until we finish. Closing your browser now may result in data loss or an incomplete submission.
    </p>
  </ngx-spinner>
  <main class="govuk-main-wrapper govuk-main-wrapper--l" id="main-content" role="main">
    <router-outlet></router-outlet>
  </main>
</div>

<app-footer></app-footer>